import { SeriousAboutTalent } from "@/ui/SeriousAboutTalent";
import { useLocale } from "@/hooks/useLocale";
import Image from "@/ui/Image";
import { Col } from "react-bootstrap";
import { stripTags } from "@/functions/stripTags";
import YoutubeVideoModal from "@/ui/YoutubeVideoModal";
import { getGlobal } from "@/functions/getGlobal";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import React from "react";

export const HiringPageContentSection = ({ className }) => {
  const global = getGlobal();
  const locale = useLocale();

  return (
    <SeriousAboutTalent
      className={className}
      tag={`page.hiring.content.tag.${locale}`}
      title={`page.hiring.content.title.${locale}`}
      text={`page.hiring.content.text.${locale}`}
      details={`page.hiring.content.details.${locale}`}
    >
      <Col xs={12} lg={6}>
        {/* START: CMS Tools editable fix */}
        <SourceFlowText
          global={global}
          path={`page.hiring.content.video.${locale}`}
          type="text"
          className="visually-hidden"
        />
        {/* END: CMS Tools editable fix */}
        <YoutubeVideoModal video_embed_url={stripTags(global[`page.hiring.content.video.${locale}`]).trim()}>
          <div className="ratio ratio-4x3 mt-4">
            <Image
              img={{
                path: "page.hiring.content.image",
                src: "/assets/hiring/content/1.jpg",
              }}
              size="622x"
              alt=""
              style={{ objectFit: "cover", objectPosition: "center right" }}
            />
          </div>
        </YoutubeVideoModal>
      </Col>
    </SeriousAboutTalent>
  );
};
